import React from 'react';
import {
	AppState,
	AuthEnvironment,
	MemberExperienceAuthProvider,
	useMemberExperienceAuth,
} from '@guildeducationinc/auth-frontend-tools';
import { AnalyticsDelayWrapper } from '@guildeducationinc/mfe-utils';
import { GUILD_DOMAIN, AUTH0_CLIENT_ID, AUTH_ENVIRONMENT } from 'src/utilities/envConfig';
import { getUpdatedURL } from 'src/utilities/urlUtility';
import { ErrorPage, Loading } from '@guildeducationinc/recess';
import { useHistory } from 'react-router-dom';

const AuthLoaderAndErrorHandler: React.FC = ({ children }) => {
	const { authError, isLoading, logout } = useMemberExperienceAuth();

	if (authError) {
		return <ErrorPage goBack={logout} message={authError.message} />;
	}

	if (isLoading) {
		return <Loading label='catalog' />;
	}

	return <>{children}</>;
};

export const AuthProviderWrapper: React.FC = ({ children }) => {
	const updatedSubdomainUrl = getUpdatedURL();
	const history = useHistory();
	const { userFromIdToken } = useMemberExperienceAuth();

	const onRedirectCallback = (appState?: AppState): void => {
		if (userFromIdToken && userFromIdToken.isVerified && appState?.returnTo?.includes('verify')) {
			window.location.href = '/';
			return;
		}
		history.replace(appState?.returnTo || window.location.pathname);
	};

	if (updatedSubdomainUrl) {
		window.location.href = updatedSubdomainUrl;
		return null;
	}

	return (
		<AnalyticsDelayWrapper>
			<MemberExperienceAuthProvider
				authEnvironment={AUTH_ENVIRONMENT as AuthEnvironment}
				clientId={AUTH0_CLIENT_ID}
				collectBasicInfoUrl={`https://profile.${GUILD_DOMAIN}`}
				forceRedirectForBasicInfoMissing={true}
				onRedirectCallback={onRedirectCallback}
				verifyUrl={`https://verify.${GUILD_DOMAIN}`}
			>
				<AuthLoaderAndErrorHandler>{children}</AuthLoaderAndErrorHandler>
			</MemberExperienceAuthProvider>
		</AnalyticsDelayWrapper>
	);
};
